<template>
    <div id="itemDetail">
        <a-row>
            <a-row >
                <a-row  type="flex" justify="space-between" class="paddingLeftRight" style="color: #ababab;font-size: 14px;margin: 10px 0 10px 27px; font-weight: 800;">
                    <a-col>Order Detail</a-col>
                    <a-col>Total: {{step2Obj == undefined ? 0 : step2Obj.length}} records  </a-col>
                </a-row>
                <a-row style="height: 80vh;overflow-y: auto">
                    <a-row v-if="step2Obj == undefined || step2Obj== null || step2Obj.length == 0" style="display: flex;justify-content: center;align-items: center;height: 100%;">
                        <a-empty />
                    </a-row>
                    <a-row v-else  type="flex" class="list_Liquor" v-for="(item,index) in step2Obj">
                        <a-col class="sbxs" @click="bigImgClick(item)">
                            <img v-if="item.photoBase != null" :src="item.photoBase" width="138" height="138">
                            <img  src="../../../../assets/img/nophoto.jpg"  width="138" height="138" v-else>
                        </a-col>

                        <a-col class="list_Liquor_detail">
                            <a-row type="flex" justify="space-between">
                                <a-col class="list_Liquor_left">
                                    <a-col class='list_Liquor_title'>{{item.wineName == '' ? '.....' : item.wineName}}</a-col>
                                    <a-col style="height: 33px">{{item.attr}}</a-col>
                                    <a-row type="flex" justify="start" style="color: #707070;font-size: 12px;">
                                        <a-col>{{item.year}}</a-col>
                                        <a-col class="ml4">{{item.itemSize}}</a-col>
                                        <a-col class="ml4">{{item.region}}</a-col>
                                    </a-row>
                                    <a-col style="color: #707070;font-size: 12px;margin: 4px 0 ">Package: {{item.packageQty}}</a-col>
                                    <a-col style="color: #707070;font-size: 12px;">Received On: {{moment(item.receivedTime).format("YYYY-MM-DD")}}</a-col>
                                </a-col>
                                <a-col class="list_Liquor_Right">
                                    <a-col style="text-align: left;">
                                        <a-col style="font-size: 13px;">Order Qty</a-col>
                                        <a-dropdown size="small" v-if="item.orderQtyFlag">
                                            <a-menu size="small" slot="overlay" @click="OrderQtyClick($event,item,index)">
                                                <a-menu-item :key="tt" v-for="tt in 9" :disabled="tt > item.availableQty ">{{tt}}</a-menu-item>
                                                <a-menu-item key="10" style="border:1px solid #efefef" :disabled="10 > item.availableQty ">10+</a-menu-item>
                                            </a-menu>
                                            <a-button size="small" style="width: 60px;"> {{item.orderQty =='' ? 0 : item.orderQty}} <a-icon style="margin-left: 15px;" type="down" /> </a-button>
                                        </a-dropdown>
                                        <a-input-number
                                                @blur="orderQtyBlur(item)"
                                                :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                                :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                                ref="orderQtyinputNumberRefs" :min="0" :max="parseInt(item.availableQty)" size="small" v-else  style="width: 60px;" v-model="item.orderQty" />
                                    </a-col>
                                    <!--:max="parseInt(item.availableQty)"-->
                                    <a-col style="margin-top: 50px;" class="sbxs">
                                        <a-popconfirm
                                                title="Are you sure delete item?"
                                                ok-text="Yes"
                                                cancel-text="No"
                                                @confirm="deleteItemDetail(item)"
                                        >
                                            <img src="../../../../assets/img/Liqutor-delete.png" width="30" height="30">
                                        </a-popconfirm>
                                    </a-col>
                                </a-col>
                            </a-row>
                        </a-col>

                    </a-row>

                </a-row>
            </a-row>
        </a-row>


        <div style="height: 45px;"></div>
        <div
              :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1,}">
            <a-button @click='next("Back")' class="fl" type="primary" size="small"><img src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button @click='stepSave("Next")' class="fr" type="primary" size="small"><img src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next</a-button>
            <div style="text-align: center">
                <a-button @click="stepSave" type="primary" size="small"><img src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save and Exit</a-button>

                <a-popconfirm
                        title="Are you sure reset?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="resetStep"
                >
                    <a-button style='margin-left: 40px;' type="danger" size="small"><img src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset</a-button>
                </a-popconfirm>

            </div>
        </div>

        <a-modal
                :title="targetImgBig.wineName"
                :visible="bigImgvis"
                :footer="null"
                width="800px"
                @cancel="() => (bigImgvis = !bigImgvis)"
        >
            <a-row type="flex" justify="start">
                <a-col style="height: 430px;overflow: auto;">
                    <a-row v-for="item in targetImgBig.pictureList">
                        <a-row class="mt4 sbxs">
                            <img v-if="item.photoBase != null" :src="item.photoBase" width="118" height="118" @click="leftPhotoXiao(item)">
                            <img src="../../../../assets/img/nophoto.jpg" width="118" height="118" v-else >
                        </a-row>
                        <a-row style="width: 94px;height: 1px;background-color: #707070;margin: 12px 0"></a-row>
                    </a-row>
                </a-col>
                <a-col style="margin-left: 4px;">
                    <img v-if="rightBigImg != null" :src="rightBigImg" width="585" height="500">
                    <img src="../../../../assets/img/nophoto.jpg" width="585" height="500"  v-else >
                </a-col>
            </a-row>
        </a-modal>


    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import moment from "moment";
    export default{
        props:{
            sellLiquor: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            initCloseValue:{
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        data(){
            return{
                step2Obj: [],
                bigImgvis: false,
                targetImgBig: {},
                rightBigImg:''
            }
        },
        created(){
            this.step2Obj = this.initCloseValue.invTempDetailList
        },
        watch:{
            initCloseValue(v){
                this.step2Obj = v.invTempDetailList
            }
        },
        methods:{
            orderQtyBlur(val){
                this.orderQtySave(val)
            },
            orderQtySave(item){
                if(item.orderQty > item.availableQty){
                    this.$message.warning('Order Qty more than Available Qty: ' + item.availableQty);
                    return
                }
                let arr = [
                    {
                        "itemSize": item.itemSize,
                        "orderQty": item.orderQty,
                        "packageQty":item.packageQty,
                        "region": item.region,
                        "sku": item.sku,
                        "wineName": item.wineName,
                        "year": item.year,
                        "skuCode": item.skuCode,
                        "receivedTime": moment(item.receivedTime).format("YYYYMMDD"),
                        "attr": item.attr
                    }
                ]
                let params = {
                    soDetail: arr,
                    currentStep: '2'
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
            moment,
//            放大图片
            bigImgClick(item){
                this.targetImgBig = item
                if(item.pictureList.length > 0 ){
                    this.rightBigImg = item.pictureList[0].photo
                }else{
                    this.rightBigImg = item.photoBase
                }
                this.bigImgvis = true
            },
            leftPhotoXiao(item){
                this.rightBigImg = item.photo
            },
//            修改order Qty
            OrderQtyClick(v,item,index){
                if(v.key == 10){
                    item.orderQtyFlag = false
                    this.$nextTick(()=>{
                        let input = this.$refs.orderQtyinputNumberRefs[index].$el.children[1].children[0]
                        input.focus()
                        input.select()
                    })
                }
                item.orderQty = v.key
                console.info(item)
                this.orderQtySave(item)
            },
            //            save
            stepSave(type){
                let arr= []
                let cacheArr = []
                for(let i in this.step2Obj){
                    if(this.step2Obj[i].orderQty > 0) {
                        const obj = {
                            "itemSize": this.step2Obj[i].itemSize,
                            "orderQty": this.step2Obj[i].orderQty,
                            "packageQty": this.step2Obj[i].packageQty,
                            "region": this.step2Obj[i].region,
                            "sku": this.step2Obj[i].sku,
                            "wineName": this.step2Obj[i].wineName,
                            "year": this.step2Obj[i].year,
                            "skuCode": this.step2Obj[i].skuCode,
                            "receivedTime": moment(this.step2Obj[i].receivedTime).format("YYYYMMDD")
                        }
                        arr.push(obj)
                        cacheArr.push(this.step2Obj[i])
                    }
                }
                if(arr.length == 0){
                    this.$message.warning('Please select your order item(s)');
                    return
                }
                let params = {
                    soDetail: arr,
                    currentStep: '2'
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        if(type == 'Next'){
                            this.$emit('goType',type)
                        }else{
                            this.$message.success(res.msg);
                            this.$emit('goClose','close')
                        }
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
//            清空后台也需要清空
            resetStep(){
                let arr = []
                for(let i in this.step2Obj){
                    const obj = {
                        "itemSize": this.step2Obj[i].itemSize,
                        "orderQty": this.step2Obj[i].orderQty,
                        "packageQty": this.step2Obj[i].packageQty,
                        "region": this.step2Obj[i].region,
                        "sku": this.step2Obj[i].sku,
                        "wineName": this.step2Obj[i].wineName,
                        "year": this.step2Obj[i].year,
                        "skuCode": this.step2Obj[i].skuCode,
                        "receivedTime": moment(this.step2Obj[i].receivedTime).format("YYYYMMDD")
                    }
                    arr.push(obj)
                }
                let params ={
                    deleteFlag: 0,
                    soDetail: arr,
                    currentStep: '2',
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.step2Obj = []
                        this.$emit('goType','step2ResetBack')
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
            //            跳转
            next(type){
                if(type == 'Next'){
                    if(this.sellLiquor.step2){

                        this.$emit('goType',type)
                    }else{
                        this.$message.warning('Please save first');
                    }
                }else{
                    this.$emit('goType',type)
                }
            },
            deleteItemDetail(item){
                for(let i in this.step2Obj){
                    if(this.step2Obj[i] == item){
                        this.step2Obj.splice(i, 1)
                    }
                }
                let params ={
                    deleteFlag: 0,
                    currentStep: '2',
                    soDetail: [
                        {
                            "itemSize": item.itemSize,
                            "orderQty": item.orderQty,
                            "packageQty": item.packageQty,
                            "region": item.region,
                            "sku": item.sku,
                            "wineName": item.wineName,
                            "year": item.year,
                            "skuCode":item.skuCode,
                            "receivedTime": moment(item.receivedTime).format("YYYYMMDD")
                        }
                    ]
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                       if(this.step2Obj.length == 0){
                           this.$emit('goType','step2ResetBack')
                       }
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            }
        }
    }
</script>
<style lang="less">
    #itemDetail{
        .list_Liquor{
            border-bottom:1px solid #b8b8b8;
            padding:6px 4px 6px 0;
            .list_Liquor_detail{
                flex: 1;
                margin-left: 10px;
                margin-top:8px;
                .list_Liquor_left{
                    .list_Liquor_title{
                        color: #698bdc;
                        font-weight: 800;
                        font-size: 14px;
                        margin-bottom: 10px;
                    }
                }
                .list_Liquor_Right{
                    color: #707070;
                    text-align: right;
                    .list_Liquor_Right_T{
                        margin-bottom: 32px;
                    }
                }
            }
        }
    }
</style>